import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean | UrlTree> => {
    const { authenticated } = authData;
    const router = inject(Router);

    // If the user is authenticated, redirect to home page
    if (authenticated) {
        const redirectUrl = router.parseUrl('');
        return redirectUrl;
    }

    // User is not authenticated, allow access to the route (e.g., login page)
    return true;
};

export const NoAuthGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
export const NoAuthChildGuard = createAuthGuard<CanActivateChildFn>(isAccessAllowed);
